var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15C18.3333 15.884 17.9821 16.7319 17.357 17.357C16.7319 17.9821 15.884 18.3333 15 18.3333C14.1159 18.3333 13.2681 17.9821 12.6429 17.357C12.0178 16.7319 11.6666 15.884 11.6666 15C11.6666 14.1159 12.0178 13.2681 12.6429 12.6429C13.2681 12.0178 14.1159 11.6666 15 11.6666C15.884 11.6666 16.7319 12.0178 17.357 12.6429C17.9821 13.2681 18.3333 14.1159 18.3333 15Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 18L30 16.6667V13.3333L26.3333 12C26 11 25.6667 10 25 9L26.6667 5.66667L24.3333 3.33333L21 5C20 4.33333 19 4 18 3.66667L16.6667 0H13.3333L12 3.66667C11 4 10 4.33333 9 5L5.66667 3.33333L3.33333 5.66667L5 9.33333C4.33333 10.3333 4 11.3333 3.66667 12.3333L0 13.3333V16.6667L3.66667 18C4 19 4.33333 20 5 21L3.33333 24.3333L5.66667 26.6667L9.33333 25C10.3333 25.6667 11.3333 26 12.3333 26.3333L13.3333 30H16.6667L18 26.3333C19 26 20 25.6667 21 25L24.3333 26.6667L26.6667 24.3333L25 20.6667C25.6667 20 26 19 26.3333 18ZM15 21.6667C11.3333 21.6667 8.33333 18.6667 8.33333 15C8.33333 11.3333 11.3333 8.33333 15 8.33333C18.6667 8.33333 21.6667 11.3333 21.6667 15C21.6667 18.6667 18.6667 21.6667 15 21.6667Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.1b95acee805b55a3df8ca7ff0e416b99.svg";
export { ForwardRef as ReactComponent };